import { render, staticRenderFns } from "./xiyaoku.vue?vue&type=template&id=0500a312&scoped=true"
import script from "./xiyaoku.vue?vue&type=script&scoped=true&lang=ts"
export * from "./xiyaoku.vue?vue&type=script&scoped=true&lang=ts"
import style0 from "./xiyaoku.vue?vue&type=style&index=0&id=0500a312&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500a312",
  null
  
)

export default component.exports